const styObj = {
  default: {
    '--page-color01': '#fafafa',
    '--page-color02': '#fafafa',
    '--page-color03': '#202326',
    '--page-color04': '#ffe5ad',
    '--page-color05': 'rgba(255, 255, 255, 0.7)',
    '--page-color06': 'rgba(255, 255, 255, 0.7)',
    '--page-color07': '#353a3f',
    '--page-color08': '#202326',
    '--page-color09': '#fafafa',
    '--page-color10': '#8e9092',
    '--page-color11': '#e3e4e5',
    '--page-color12': '#8e9092',
    '--page-color13': '#ffa433',
    '--page-color14': '#ffa433',
    '--page-color15': '#ffa433',
    '--page-color16': '#202326',
    '--page-color17': '#fff4d6',
    '--page-color18': '#ffb94d',
    '--page-color19': '#ffa433',
    '--page-color20': '#733406',
    '--page-color21': '#fff4d6',
    '--page-color22': 'rgba(255, 255, 255, 0)',
    '--page-color23': '#202326',
    '--page-color24': '#353a3f',
    '--page-color25': '#f0f1f2',
    '--page-color26': '#353a3f',
    '--page-color27': '#353a3f',
    '--page-color28': '#f0f1f2',
    '--page-color29': '#ffe41c',
    '--page-color30': '#733406',
    '--page-color31': '#ffa433',
    '--page-color32': '#733406',
    '--page-color33': 'rgba(0, 0, 0, 0.7)',
    '--page-color34': '#fff',
    '--page-color35': '#fff4d6',
    '--page-color36': 'rgba(255, 255, 255, 0)',
    '--page-color37': '#000',
    '--page-color38': '#353a3f',
    '--page-color39': '#fff4d6',
    '--page-color40': '#733406',
    '--page-color41': '#ffa433',
    '--page-color42': '#733406',
    '--page-color43': '#8e9092',
    '--page-color44': '#fafafa',
    '--page-radius1': '56px',
    '--page-radius2': '32px',
    '--page-radius3': '24px',
    '--page-radius4': '48px',
    '--icon-bg1': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/bg1.png')})`,
    '--icon-bg2': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/bg2.png')})`,
    '--icon-bg3': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/bg3.png')})`,
    '--icon-bg5': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/bg5.png')})`,
    '--icon-bg6': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/bg6.png')})`,
    '--icon-bg7': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/bg7.png')})`,
    '--icon-bg8': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/bg8.png')})`,
    '--icon-bg9': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/bg9.png')})`,
    '--icon-got': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/got.png')})`,
    '--icon-time': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/time.png')})`,
    '--icon-switchoff': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/switch-off.png')})`,
    '--icon-switchon': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/switch-on.png')})`
  },
  joyu: {
    '--page-color01': '#fafafa',
    '--page-color02': '#fafafa',
    '--page-color03': '#0C0E11',
    '--page-color04': '#FFD3BB',
    '--page-color05': 'rgba(255, 255, 255, 0.7)',
    '--page-color06': 'rgba(255, 255, 255, 0.7)',
    '--page-color07': '#353a3f',
    '--page-color08': '#8E9092',
    '--page-color09': '#fafafa',
    '--page-color10': '#8e9092',
    '--page-color11': '#e3e4e5',
    '--page-color12': '#8e9092',
    '--page-color13': '#FF6A55',
    '--page-color14': '#FF6A55',
    '--page-color15': '#FF6A55',
    '--page-color16': '#0C0E11',
    '--page-color17': '#FFECDD',
    '--page-color18': '#FF997F',
    '--page-color19': '#FF6A55',
    '--page-color20': '#5A0B1B',
    '--page-color21': '#FFECDD',
    '--page-color22': 'rgba(255, 255, 255, 0)',
    '--page-color23': '#202326',
    '--page-color24': '#353a3f',
    '--page-color25': '#f0f1f2',
    '--page-color26': '#353a3f',
    '--page-color27': '#353a3f',
    '--page-color28': '#f0f1f2',
    '--page-color29': '#FFD747',
    '--page-color30': '#5A0B1B',
    '--page-color31': '#FF6A55',
    '--page-color32': '#5A0B1B',
    '--page-color33': 'rgba(0, 0, 0, 0.7)',
    '--page-color34': '#ffffff',
    '--page-color35': '#FFECDD',
    '--page-color36': 'rgba(255, 255, 255, 0)',
    '--page-color37': '#0C0E11',
    '--page-color38': '#353a3f',
    '--page-color39': '#F0F1F2',
    '--page-color40': '#5A0B1B',
    '--page-color41': '#FF6A55',
    '--page-color42': '#5A0B1B',
    '--page-color43': '#8e9092',
    '--page-color44': '#fafafa',
    '--page-radius1': '4px',
    '--page-radius2': '4px',
    '--page-radius3': '4px',
    '--page-radius4': '4px',
    '--icon-bg1': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/joyu/bg1.png')})`,
    '--icon-bg2': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/joyu/bg2.png')})`,
    '--icon-bg3': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/bg3.png')})`,
    '--icon-bg5': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/bg5.png')})`,
    '--icon-bg6': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/bg6.png')})`,
    '--icon-bg7': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/bg7.png')})`,
    '--icon-bg8': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/bg8.png')})`,
    '--icon-bg9': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/bg9.png')})`,
    '--icon-got': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/got.png')})`,
    '--icon-time': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/joyu/time.png')})`,
    '--icon-switchoff': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/joyu/switch-off.png')})`,
    '--icon-switchon': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/joyu/switch-on.png')})`
  },
  vibeo: {
    '--page-color01': '#fafafa',
    '--page-color02': '#fafafa',
    '--page-color03': '#202326',
    '--page-color04': '#ffe5ad',
    '--page-color05': 'rgba(255, 255, 255, 0.7)',
    '--page-color06': 'rgba(255, 255, 255, 0.7)',
    '--page-color07': '#353a3f',
    '--page-color08': '#202326',
    '--page-color09': '#fafafa',
    '--page-color10': '#8e9092',
    '--page-color11': '#e3e4e5',
    '--page-color12': '#8e9092',
    '--page-color13': '#ffa433',
    '--page-color14': '#ffa433',
    '--page-color15': '#ffa433',
    '--page-color16': '#202326',
    '--page-color17': '#fff4d6',
    '--page-color18': '#ffb94d',
    '--page-color19': '#ffa433',
    '--page-color20': '#733406',
    '--page-color21': '#fff4d6',
    '--page-color22': 'rgba(255, 255, 255, 0)',
    '--page-color23': '#202326',
    '--page-color24': '#353a3f',
    '--page-color25': '#f0f1f2',
    '--page-color26': '#353a3f',
    '--page-color27': '#353a3f',
    '--page-color28': '#f0f1f2',
    '--page-color29': '#ffe41c',
    '--page-color30': '#733406',
    '--page-color31': '#ffa433',
    '--page-color32': '#733406',
    '--page-color33': 'rgba(0, 0, 0, 0.7)',
    '--page-color34': '#fff',
    '--page-color35': '#fff4d6',
    '--page-color36': 'rgba(255, 255, 255, 0)',
    '--page-color37': '#000',
    '--page-color38': '#353a3f',
    '--page-color39': '#fff4d6',
    '--page-color40': '#733406',
    '--page-color41': '#ffa433',
    '--page-color42': '#733406',
    '--page-color43': '#8e9092',
    '--page-color44': '#fafafa',
    '--page-radius1': '56px',
    '--page-radius2': '32px',
    '--page-radius3': '24px',
    '--page-radius4': '48px',
    '--icon-bg1': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/bg1.png')})`,
    '--icon-bg2': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/bg2.png')})`,
    '--icon-bg3': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/bg3.png')})`,
    '--icon-bg5': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/bg5.png')})`,
    '--icon-bg6': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/bg6.png')})`,
    '--icon-bg7': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/bg7.png')})`,
    '--icon-bg8': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/bg8.png')})`,
    '--icon-bg9': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/bg9.png')})`,
    '--icon-got': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/got.png')})`,
    '--icon-time': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/time.png')})`,
    '--icon-switchoff': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/switch-off.png')})`,
    '--icon-switchon': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/switch-on.png')})`
  },
  whonow: {
    '--page-color01': '#fafafa',
    '--page-color02': '#fafafa',
    '--page-color03': '#202326',
    '--page-color04': '#EAF5C8',
    '--page-color05': 'rgba(255, 255, 255, 0.7)',
    '--page-color06': 'rgba(255, 255, 255, 0.7)',
    '--page-color07': '#353a3f',
    '--page-color08': '#202326',
    '--page-color09': '#fafafa',
    '--page-color10': '#8e9092',
    '--page-color11': '#e3e4e5',
    '--page-color12': '#8e9092',
    '--page-color13': '#B9E86F',
    '--page-color14': '#B9E86F',
    '--page-color15': '#B9E86F',
    '--page-color16': '#202326',
    '--page-color17': '#EAF5C8',
    '--page-color18': '#C7E77E',
    '--page-color19': '#B9E86F',
    '--page-color20': '#102006',
    '--page-color21': '#EAF5C8',
    '--page-color22': 'rgba(255, 255, 255, 0)',
    '--page-color23': '#202326',
    '--page-color24': '#353a3f',
    '--page-color25': '#f0f1f2',
    '--page-color26': '#353a3f',
    '--page-color27': '#353a3f',
    '--page-color28': '#f0f1f2',
    '--page-color29': '#FFE630',
    '--page-color30': '#102006',
    '--page-color31': '#B9E86F',
    '--page-color32': '#102006',
    '--page-color33': 'rgba(0, 0, 0, 0.7)',
    '--page-color34': '#ffffff',
    '--page-color35': '#EAF5C8',
    '--page-color36': 'rgba(255, 255, 255, 0)',
    '--page-color37': '#000000',
    '--page-color38': '#353a3f',
    '--page-color39': '#EAF5C8',
    '--page-color40': '#102006',
    '--page-color41': '#B9E86F',
    '--page-color42': '#102006',
    '--page-color43': '#8e9092',
    '--page-color44': '#fafafa',
    '--page-radius1': '56px',
    '--page-radius2': '32px',
    '--page-radius3': '24px',
    '--page-radius4': '48px',
    '--icon-bg1': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/whonow/bg1.png')})`,
    '--icon-bg2': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/whonow/bg2.png')})`,
    '--icon-bg3': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/bg3.png')})`,
    '--icon-bg5': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/whonow/bg5.png')})`,
    '--icon-bg6': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/whonow/bg6.png')})`,
    '--icon-bg7': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/bg7.png')})`,
    '--icon-bg8': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/bg8.png')})`,
    '--icon-bg9': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/whonow/bg9.png')})`,
    '--icon-got': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/whonow/got.png')})`,
    '--icon-time': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/whonow/time.png')})`,
    '--icon-switchoff': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/whonow/switch-off.png')})`,
    '--icon-switchon': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/whonow/switch-on.png')})`
  }
}

export const pageCssVars = {
  methods: {
    cssVars() {
      if (this.packageName) {
        // 有配置
        if (styObj[this.packageName]) {
          return styObj[this.packageName]
        }
        // 未配置
        else {
          return styObj['default']
        }
      }
      return {}
    }
  }
}
